import { ClassicPreset, GetSchemes } from 'rete';
import { SelectableConnection } from '../connections/models/SelectableConnection';
import { SocketSelection } from '../core/socket-selection';

type Schemes = GetSchemes<ClassicPreset.Node, ClassicPreset.Connection<ClassicPreset.Node, ClassicPreset.Node>>;

export class DesignerSelection {
    public constructor(
        public selectedNode: Schemes['Node'],
        public selectedConnection: SelectableConnection,
        public selectedSocket: SocketSelection,
        public previousSelection: DesignerSelection
    ) {}
}
